import { EventEmitter, Inject, Injectable, Optional, Type } from "@angular/core";
import { Subject } from "rxjs";

import { MedPopperContent } from "../types";
import { MedHostDirective } from "../directives/med-host.directive";

export const MED_POPUP_COMPONENTS_MAP = "medPopupComponentsMap";
export const MED_POPUP_SIZES_MAP = "medPopupSizesMap";
const DEFAULT_MAX_WIDTH = "260px";
const NORMAL_COUNT_OF_ACTIVE_ITEMS = 1;

@Injectable({
  providedIn: "root",
})
export class MedPopupService<InputType, OutputType> {
  constructor(
    @Inject(MED_POPUP_COMPONENTS_MAP) private componentsMap: Map<string, Type<MedPopperContent<any, any>>>,
    @Optional() @Inject(MED_POPUP_SIZES_MAP) private sizesMap: Map<string, string>,
  ) {}

  host?: MedHostDirective;
  popupContentEl!: HTMLElement;
  maxWidth = DEFAULT_MAX_WIDTH;
  readonly registerOfActives: Record<string, boolean> = {};
  readonly clickOutside$: Subject<EventTarget> = new Subject();

  get hasMoreActives(): boolean {
    return Object.values(this.registerOfActives).filter(Boolean).length > NORMAL_COUNT_OF_ACTIVE_ITEMS;
  }

  show(type: string, data?: InputType): EventEmitter<OutputType> {
    if (this.host === undefined) {
      throw new Error("Unknown modal content host");
    }

    this.host.viewContainerRef.clear();

    const component = this.componentsMap.get(type);
    const componentRef = this.host.viewContainerRef.createComponent<MedPopperContent<InputType, OutputType>>(component as any);
    componentRef.instance.data = data;
    this.maxWidth = this.sizesMap?.get(type) || DEFAULT_MAX_WIDTH;

    return componentRef.instance.emitEvent;
  }

  hideActives(): void {
    Object.keys(this.registerOfActives).forEach(key => this.setActive(key, false));
  }

  setActive(hash: string, enabled: boolean): void {
    this.registerOfActives[hash] = enabled;

    if (!enabled) {
      this.host?.viewContainerRef.clear();
    }
  }

  deleteActive(hash: string): void {
    delete this.registerOfActives[hash];
  }
}
